var map = {
	"./TheRiseFramework.png": "89b9",
	"./TheRiseFrameworkColored.jpg": "d79b",
	"./TheRiseFrameworkNavy.png": "d4a9",
	"./bg-waves.png": "5bbd",
	"./bg.jpg": "86d5",
	"./bhi_logo.png": "2c29",
	"./brainhealth-logo.png": "cc81",
	"./brainhealth-logo.svg": "3942",
	"./chat-pin-active.svg": "bc92",
	"./chat-pin.svg": "44c7",
	"./comment.png": "6ae1",
	"./empty-notification-bell.png": "9ac8",
	"./emptyChat.svg": "df8c",
	"./fif-error.png": "ddd8",
	"./fif-measurement.png": "4d0a",
	"./fif-photo-placeholder.jpg": "42d2",
	"./fif-questions.png": "09a3",
	"./fif-success.png": "d7ef",
	"./fif-weight.png": "8d3c",
	"./fif-welcome.png": "774f",
	"./fonts/bhicons.eot": "a370",
	"./fonts/bhicons.svg": "76e7",
	"./fonts/bhicons.ttf": "e645",
	"./fonts/bhicons.woff": "55f8",
	"./fonts/selection": "5943",
	"./fonts/selection.json": "5943",
	"./giphyLogo.png": "421a",
	"./heart_pulse.png": "6031",
	"./kr.png": "6f16",
	"./loggedPlaceholder96x96.png": "80e9",
	"./logo-keep-rising-white.png": "2b04",
	"./logo-white.png": "d939",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./meal_placeholder.png": "87c6",
	"./obd_logo.png": "f888",
	"./placeholder48x54.png": "7ff5",
	"./placeholder96x96.png": "f3b6",
	"./placeholder_doc.png": "2839",
	"./placeholder_image.png": "7034",
	"./placeholder_note.png": "1a98",
	"./placeholder_other.png": "ffe0",
	"./placeholder_pdf.png": "457b",
	"./placeholder_presentation.png": "a57d",
	"./placeholder_sheet.png": "1f0c",
	"./placeholder_video.png": "23a5",
	"./reactions/bh-heart.svg": "0677",
	"./reactions/ss-logo-icon.svg": "8632",
	"./scale.png": "2303",
	"./screener-icons/cognitive_stimulation.png": "bfc5",
	"./screener-icons/emotional_wellbeing.png": "4933",
	"./screener-icons/general_health.png": "85a8",
	"./screener-icons/home_environment.png": "b662",
	"./screener-icons/meaning_and_purpose.png": "7aaa",
	"./screener-icons/nutrition.png": "89de",
	"./screener-icons/physical_activity.png": "3b4d",
	"./screener-icons/positive_impacts.png": "0308",
	"./screener-icons/sleep.png": "a70d",
	"./screener-icons/social_connection.png": "3113",
	"./screener-icons/stress_resilience.png": "1e26",
	"./screener-icons/the-rise-framework/copy-catter.png": "e8f4",
	"./screener-icons/the-rise-framework/day-jobber.png": "2e4d",
	"./screener-icons/the-rise-framework/defender.png": "8452",
	"./screener-icons/the-rise-framework/feature-lister.png": "e321",
	"./screener-icons/the-rise-framework/glorifier.png": "7a60",
	"./screener-icons/the-rise-framework/interrogator.png": "6184",
	"./screener-icons/the-rise-framework/overexplainer.png": "5ae9",
	"./screener-icons/the-rise-framework/pillar-pitcher.png": "38d0",
	"./screener-icons/the-rise-framework/schmoozer.png": "65cb",
	"./screener-icons/the-rise-framework/tactician.png": "9c84",
	"./sneakers.png": "39ef",
	"./ss.png": "88d6",
	"./stickers/chef.png": "d13e",
	"./stickers/clapping.png": "d775",
	"./stickers/crossed-fingers.png": "a353",
	"./stickers/drinking-coffee.png": "c42f",
	"./stickers/eating-burger.png": "72ba",
	"./stickers/excited.png": "688d",
	"./stickers/exercise-dumbbell.png": "a43c",
	"./stickers/exercise.png": "a830",
	"./stickers/exhausted.png": "4a7e",
	"./stickers/fist-hand.png": "3b01",
	"./stickers/good-morning.png": "c280",
	"./stickers/hands-up.png": "f4d7",
	"./stickers/happy-cute-smiling.png": "8e26",
	"./stickers/happy-raising-hands.png": "0d18",
	"./stickers/happy-walking.png": "3b60",
	"./stickers/laughing-smiley.png": "a4d6",
	"./stickers/lemonade.png": "47a7",
	"./stickers/meditating.png": "10b5",
	"./stickers/ok.png": "78a9",
	"./stickers/pleasing.png": "495f",
	"./stickers/pointing-himself.png": "c703",
	"./stickers/pointing-laughing-2.png": "35f4",
	"./stickers/pointing-laughing.png": "4b9e",
	"./stickers/rage.png": "84ba",
	"./stickers/running-sweating.png": "e6b1",
	"./stickers/shout.png": "a60e",
	"./stickers/shrugs-shoulders.png": "7714",
	"./stickers/size-fingers.png": "c2bb",
	"./stickers/skipping-jump-rope.png": "76fa",
	"./stickers/sleeping-smiley.png": "4cc6",
	"./stickers/star.png": "913e",
	"./stickers/tears-joy.png": "c414",
	"./stickers/watching-tv-pizza.png": "e81a",
	"./stickers/weakness.png": "b2b0",
	"./stickers/weightlifter.png": "4180",
	"./stickers/wink-ok.png": "7163",
	"./stickers/yawning.png": "c0b8",
	"./the-rise-framework-cover-book.jpg": "d6e8",
	"./water_glasses.png": "9e15"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";